/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardLimitCreditDatesResponseViewModel } from "../types/CreditCardLimitCreditDatesResponseViewModel.ts";

export const creditCardLimitCreditDatesResponseViewModelSchema = z.object({
  installment: z.number().int().nullish(),
  creditDate: z.string().datetime().nullish(),
}) as unknown as ToZod<CreditCardLimitCreditDatesResponseViewModel>;
